"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var react_i18next_1 = require("react-i18next");
var transformText = function (text, options) {
    var transformedText = text;
    if (options.transform) {
        transformedText = options.transform(transformedText);
    }
    if (options.uppercase) {
        transformedText = lodash_1.toUpper(transformedText);
    }
    if (options.camelcase) {
        transformedText = lodash_1.camelCase(transformedText);
    }
    if (options.capitalize) {
        transformedText = lodash_1.capitalize(transformedText);
    }
    return transformedText;
};
var translateParams = function (t, params) {
    if (params) {
        var result_1 = {};
        Object.getOwnPropertyNames(params).forEach(function (key) {
            if (params[key]) {
                result_1[key] = t(params[key]);
            }
        });
        return result_1;
    }
    return undefined;
};
var FormatText = function (props) {
    var id = props.id, uppercase = props.uppercase, transform = props.transform, camelcase = props.camelcase, capitalize = props.capitalize, params = props.params, restProps = __rest(props, ["id", "uppercase", "transform", "camelcase", "capitalize", "params"]);
    var t = react_i18next_1.useTranslation().t;
    var message = react_1.useMemo(function () {
        if (id) {
            var translatedParams = translateParams(t, params);
            var translatedMessage = t(id, translatedParams);
            return transformText(translatedMessage, { uppercase: uppercase, transform: transform, camelcase: camelcase, capitalize: capitalize });
        }
        return '';
    }, [t, id, params, uppercase, transform, camelcase, capitalize]);
    return id ? (react_1.default.createElement("span", __assign({ className: "ant-app-text" }, restProps), message)) : null;
};
exports.default = FormatText;
